import { render } from "./WhyCleaner.vue?vue&type=template&id=46fd7633"
import script from "./WhyCleaner.vue?vue&type=script&lang=js"
export * from "./WhyCleaner.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rnedkov/Documents/GitHub/cleaner-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__